import { Component, OnInit, VERSION, ViewChild, ElementRef, Renderer2, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-input-num-format',
  templateUrl: './input-num-format.component.html',
  styleUrls: ['./input-num-format.component.css']
})
export class InputNumFormatComponent implements OnInit {
  // name: string;
  @ViewChild('commaInput') commaInput: ElementRef;
  public listener: () => void;
  @Input() num: number;
  @Input() is_disable: boolean = false;
  @Output('change') numChange = new EventEmitter<number>();
  constructor(private renderer: Renderer2) { 
    // this.name = `Angylar! v${VERSION.full}`
  }
  ngOnChanges(changes) {
    //console.log('Changed', changes.property.currentValue, changes.property.previousValue);
  }

  ngOnInit() {
    //console.log('Init', this.disabled);
  }


  public onInputChange(event: any) {
    if (event.replace(/\D/g, '') === '') {
      this.num = null;
    } else {
      this.num = Number(event.replace(/\D/g, ''));
    }
    if (this.num === null || this.num.toString() === '') {
      this.num = 0;
      this.numChange.emit(this.num);
    }
    this.numChange.emit(this.num);
  }

  public onFocus() {
    this.listener = this.renderer.listen('window', 'keyup', event => {
      this.commaInput.nativeElement.value = this.commaInput.nativeElement.value.replace(/[^\d,]/g, '');
    });
  }

  public onBlur() {
    this.listener();
    if (this.num.toString() === '') {

    }
    // this.numChange.emit(this.num);
  }

  public reset(){
    this.num = 0;
    this.numChange.emit(this.num);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/input-num-format/input-num-format.component.ts